import MicroModal from 'micromodal';

export default {

  init() {

    $('a[href="#modal-contact"]').each(function() {
      $(this).attr('data-micromodal-trigger', "modal-contact");
    });

    $('[data-micromodal-trigger]').on('click', function(e) {
      e.preventDefault();

      var trigger = this.getAttribute('data-micromodal-trigger');
      var modal = document.getElementById(trigger);

      var data = {
        videoProvider: this.getAttribute('data-video-provider'),
        videoUrl: this.getAttribute('data-video-url'),
        videoId: this.getAttribute('data-video-id')
      }
      
      console.log(modal);

      $(modal).data(data);
    });

    MicroModal.init({
      onShow: this.show,
      onClose: this.hide,
      disableFocus: true,
      debugMode: true
    });
  },

  show(modal) {
    const $modal = $(modal);
    const platform = $modal.data('videoProvider');
    const url = $modal.data('videoUrl');

    if (!url || !platform) {
      return;
    }

    // Close by id breaks the opening modal
    if($('#modal-gated.is-open').length) {
      $('#modal-gated.is-open').find('[data-micromodal-close]').trigger('click');
    }

    let template = Video.getTemplate(Video.getVideoId(url, platform), platform);

    $(modal).find('#video-element').html(template);
    Video.trackVideo();
  },

  hide(modal) {
    $(modal).find('#video-element').html('');
  }

};
